module.exports = __webpack_public_path__ + "static/media/spain.e6243cea.svg";